import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { RankMutationKeys } from '../../../keys'
import {
	UpdateRankUpRewardsRequest,
	UpdateRankUpRewardsResponse,
} from '../../../type'
import { updateRankUpRewards } from '../../services'

interface UpdateRankUpRewardsParams {
	id: string
	payload: UpdateRankUpRewardsRequest
}

export default function useMutationUpdateRankUpRewards(
	props?: UseBaseMutationOptions<
		UpdateRankUpRewardsResponse,
		UpdateRankUpRewardsParams
	>,
) {
	return useMutation({
		mutationKey: [RankMutationKeys.UpdateRankUpRewards],
		mutationFn: (params) => updateRankUpRewards(params.id, params.payload),
		...props,
	})
}
